import { render, staticRenderFns } from "./CellRendererAvatar.vue?vue&type=template&id=47bbea63&scoped=true&"
import script from "./CellRendererAvatar.vue?vue&type=script&lang=js&"
export * from "./CellRendererAvatar.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererAvatar.vue?vue&type=style&index=0&id=47bbea63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bbea63",
  null
  
)

export default component.exports